<template>
  <main class="main product-list-page page-inside">
    <div class="main-wrapper">
      <section class="section hero-section product-list-section">
        <div class="wrapper">
          <div class="title regular">Browse high-quality prompts.</div>
          <div class="bar">
            <div class="bar-left">
              <div
                :class="[
                  'desc small bar-desc',
                  { active: categoryListIsVisible },
                ]"
                @click="categoryListIsVisible = !categoryListIsVisible"
              >
                <b>Categories</b>
                <img
                  src="./../img/caret.svg"
                  :class="['img', { active: categoryListIsVisible }]"
                />
              </div>
              <div class="tag-list" v-if="category && category.length">
                <template v-for="item in category">
                  <label
                    class="product-list-checkbox chekbox-label"
                    :key="item.id"
                    v-if="item.name"
                  >
                    <div class="chekbox-label-wrapper">
                      <input
                        type="checkbox"
                        v-model="category"
                        :id="item.name"
                        :value="item"
                        @change="onSelectCategory()"
                      />
                      <div class="checkbox"></div>
                      <div class="desc">{{ item.name }}</div>
                    </div>
                  </label>
                </template>
              </div>
            </div>
            <div class="button clear" @click="clearFilters">Clear all</div>

            <div
              class="product-list-checkbox-list-container dropdown"
              v-if="categoryListIsVisible"
            >
              <template v-for="(modelItem, i) in $parent.modelOptions">
                <div
                  class="product-list-checkbox-list"
                  v-if="modelItem.id == model.id"
                  :key="i"
                >
                  <label
                    class="product-list-checkbox chekbox-label"
                    v-for="item in $parent.categoryCreateOptions.filter(
                      (item) => item.parent_id === modelItem.id
                    )"
                    :key="item.id"
                  >
                    <div class="chekbox-label-wrapper">
                      <input
                        type="checkbox"
                        v-model="category"
                        :id="item.name"
                        :value="item"
                        @change="onSelectCategory()"
                      />
                      <div class="checkbox"></div>
                      <div class="desc">{{ item.name }}</div>
                    </div>
                  </label>
                </div>
              </template>
            </div>
          </div>
        </div>
      </section>
      <section class="section product-list-section2">
        <div class="wrapper">
          <div class="left">
            <div class="select-container" v-if="$parent.categoryOptions.length">
              <div class="model-section">
                <div class="tab-list">
                  <template v-for="item in modelOptions">
                    <div class="chekbox-container" :key="item.id">
                      <label class="tab-container chekbox-label">
                        <div class="chekbox-label-wrapper">
                          <input
                            type="radio"
                            v-model="model"
                            :value="item"
                            @change="onSelectModel()"
                          />
                          <div class="checkbox"></div>
                          <div class="checkbox-tab desc small">
                            <span>{{ item.title }}</span>
                          </div>
                        </div>
                      </label>
                    </div>
                  </template>
                  <div class="chekbox-container">
                    <label class="tab-container chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input
                            type="checkbox"
                            :value="onlyPacks"
                            @change="toggleOnlyPacks"
                        />
                        <div class="checkbox"></div>
                        <div class="checkbox-tab desc small">
                          <span>Packs</span>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <transition name="fade">
              <div class="list products" v-if="$parent.productList">
                <div
                  class="item"
                  v-for="(item, i) in $parent.productList"
                  :key="i"
                >
                  <ProductCard
                    :currencyValue="currencyValue"
                    @openBuyModal="openBuyModal"
                    :models="$parent.modelOptions"
                    :tag="item.parent_cat_id"
                    :item="item"
                    :sliderIsClickble="true"
                    @goToProduct="goToProduct"
                    :currency="currency"
                  />
                </div>
                <div
                  class="title no-products"
                  v-if="!$parent.productList.length"
                ></div>
                <div
                  class="title no-products"
                  v-if="!$parent.productList.length"
                >
                  No products!
                </div>
                <div
                  class="title no-products"
                  v-if="!$parent.productList.length"
                ></div>
              </div>
            </transition>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import ProductCard from "../components/ProductCard.vue";


export default {
  name: "ProductList",
  props: [
    "currency",
    "activeModels",
    "onlyPacks",
    "activeCategories",
    "models",
    "modelOptions",
    "currencyValue",
    "categoryOptions",
  ],
  components: {
    ProductCard,
  },
  data: function () {
    return {
      imgDomain: "",
      category: [],
      model: [],
      productList: {},
      categoryListIsVisible: false,
    };
  },
  watch: {
    activeModels: function (newVal) {
      this.model = newVal;
      if (this.categoryOptions) {
        this.category = this.categoryOptions.filter(
          (item) => item.parent_id === this.model.id
        );
      }
    },
    categoryOptions: function (newVal) {
      console.log(34);
      if (this.model) {
        this.category = newVal.filter(
          (item) => item.parent_id === this.model.id
        );
      }
      if (Array.isArray(newVal)) {
        this.category = newVal;
      } else {
        let newArray = [];
        newArray.push(newVal);
        let mapped = newArray.map(({ id, title: name, parent_id }) => ({
          id,
          name,
          parent_id,
        }));

        this.category = mapped;
      }
    },
    activeCategories: function (newVal) {
      if (Array.isArray(newVal)) {
        this.category = newVal;
      } else {
        let newArray = [];
        newArray.push(newVal);
        let mapped = newArray.map(({ id, title: name, parent_id }) => ({
          id,
          name,
          parent_id,
        }));

        this.category = mapped;
      }
    },
    models: function (newVal) {
      this.$emit("setActiveModel", newVal);
    },
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;

    let self = this;
    setTimeout(function () {
      console.log(self.model);
      if (Array.isArray(self.model)) {
        self.$emit("setActiveModel", self.models);
        self.setCat();
      }
    }, 500);

    if (this.$parent.activeCategory) {
      this.category = [];
      this.$emit("setActiveCategory", this.$parent.activeCategory);
      this.$emit("chooseCategory", "");
    }
    this.setCat();
  },
  methods: {
    setCat() {
      if (this.activeCategories) {
        if (Array.isArray(this.activeCategories)) {
          this.category = this.activeCategories;
        } else {
          let newArray = [];
          newArray.push(this.$parent.activeCategories);
          let mapped = newArray.map(({ id, title: name, parent_id }) => ({
            id,
            name,
            parent_id,
          }));
          this.category = mapped;
        }
      }
    },
    toggleOnlyPacks() {
      console.log(this.onlyPacks, 'toggleOnlyPacks')
      this.$emit("setOnlyPacks", !this.onlyPacks);
    },
    onSelectModel() {
      this.$emit("setActiveModel", this.model);
    },
    onSelectCategory() {
      this.$emit("setActiveCategory", this.category);
    },
    resetFilters() {
      this.$parent.setAllModels();
      this.$parent.openProducts();
    },
    clearFilters() {
      this.$emit("chooseCategory", "");
      this.$emit("setActiveCategory", "");
      this.category = "";
    },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    openBuyModal(item, type) {
      this.$emit("openBuyModal", item, type);
    },
  },
};
</script>
